import { Component, Input, OnInit } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { Swiper, SwiperOptions } from 'swiper/types';
import { IconFrame } from '@app/icon-library/lib/pl-icon.component';
import { A11y, Pagination } from 'swiper/modules';

@Component({
  selector: 'pl-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @Input() public slidesContent: string[] = [];
  @Input() public showDots: boolean = true;

  public readonly IconFrame: typeof IconFrame = IconFrame;
  public readonly PlIcon: typeof PlIcon = PlIcon;

  private swiperInstance: Swiper | null = null;

  public config: SwiperOptions | null = null;

  public ngOnInit(): void {
    this.config = {
      modules: [Pagination, A11y],
      a11y: {
        enabled: true,
      },
      keyboard: true,
      navigation: false,
      pagination: this.showDots ? { clickable: true, dynamicBullets: true, dynamicMainBullets: 10 } : false,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      on: {
        init: (swiper: Swiper): void => {
          this.swiperInstance = swiper;
        },
      },
    };
  }

  public get swiper(): Swiper {
    if (this.swiperInstance) {
      return this.swiperInstance;
    }

    throw new Error(`Swiper is not initialised yet, this should not happen`);
  }

  public onPrevButtonClicked(): void {
    this.swiper.slidePrev();
  }

  public onNextButtonClicked(): void {
    this.swiper.slideNext();
  }
}
